module.exports = __webpack_public_path__ + "img/shopcar1.1b6a839b.png";